import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left"},[_c('div',{staticClass:"mt-4 mb-0 mb-md-6"},[_c('div',{staticClass:"d-flex align-center"},[_c(VAlert,{staticClass:"mt-4",attrs:{"type":"info","outlined":""}},[_vm._v(" Cette section est en cours de développement. Revenez prochainement pour découvrir de nouvelles fonctionnalités ! ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }